

































import { defineComponent } from '@nuxtjs/composition-api'
import ChimerasLinks from './ChimerasLinks.vue'
import { useI18n } from '~/composables/i18n'
import { SIGNALSTAR_FLUORESCENCE_REMOVAL_KIT, INTRASEQ_TEMPLATES } from '@/common/utils/product/constants'
import ConjugatesLinks from '@/components/feature/price-brick/ConjugatesLinks.vue'
import IntraseqLinks from '@/components/feature/price-brick/IntraseqLinks.vue'

export default defineComponent({
  components: { ConjugatesLinks, IntraseqLinks, ChimerasLinks },
  props: {
    customFormulationPath: {
      type: String,
      required: true,
    },
    addToBasketButtonText: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
    customFormulationLabel: {
      type: String,
      required: false,
      default: null,
    },
    templateTitle: {
      type: String,
      required: false,
      default: null,
    },
  },
  emits: ['add-to-basket'],
  setup(props) {
    const { t } = useI18n()
    const showCustomConjugation = INTRASEQ_TEMPLATES.includes(props.templateTitle)
    return {
      t,
      SIGNALSTAR_FLUORESCENCE_REMOVAL_KIT,
      showCustomConjugation,
    }
  },
})
